export const DELETE_ITEM_IMAGE = 'DELETE_ITEM_IMAGE';
export const FETCHED_POPUP_DATA = 'FETCHED_POPUP_DATA';
export const UPDATE_ITEM_IMAGE = 'UPDATE_ITEM_IMAGE';
export const UPDATE_ITEM_IMAGE_CROP = 'UPDATE_ITEM_IMAGE_CROP';
export const UPDATE_ITEM_IMAGE_CROP_RATIO = 'UPDATE_ITEM_IMAGE_CROP_RATIO';
export const UPDATE_ITEM_IMAGE_CROP_THUMB = 'UPDATE_ITEM_IMAGE_CROP_THUMB';
export const UPDATE_ITEM_IMAGE_META = 'UPDATE_ITEM_IMAGE_META';
export const UPDATE_ITEM_TEXT = 'UPDATE_ITEM_TEXT';
export const UPDATE_SECTION_TITLE = 'UPDATE_SECTION_TITLE';
export const UPDATE_SECTION_SETTING = 'UPDATE_SECTION_SETTING';



// WEBPACK FOOTER //
// ./src/containers/builder/sections/types/text_columns_multiple_media.js